
<div mat-dialog-title>Export Portfolio Result Detail<button class="close" mat-button data-cancel-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i>
</button></div>
<mat-dialog-content>
  @if (isDetail) {
    <div data-detail-message>
      <p>You can export the selected sections of this page to a PDF.</p>
      <p>To export multiple, pending portfolio results, go the the Rebalance Summary screen.</p>
    </div>
  }

  @if (isSummary) {
    <div data-summary-message>
      <p>The results for the portfolios you selected will be exported to a PDF. Each portfolio will be shown separately,
      and the PDF will contain the sections you select below.</p>
      <p>Please note: You are only able to export multiple results for portfolios in a pending state. If you want to
        export a PDF for a portfolio in a state other than pending, go to the result detail screen for that portfolio and
      export from there.</p>
    </div>
  }
  <h3 data-rebalance-name [innerText]="this.data.rebalanceName + '_' + this.data.rebalanceId"></h3>
  @if (isSummary) {
    <h4 data-portfolios-selected
    [innerText]="this.data.selectedPortfolios.length + ' portfolio(s) selected'"></h4>
  }

  @if (!isFormValid) {
    <mat-card class="block error" data-no-selection-error-message>
      <mat-card-title style="white-space: pre-line;">
        Please select at least one section to include in the export.
      </mat-card-title>
    </mat-card>
  }

  <form [formGroup]="formGroup">
    <h4>Include these sections:</h4>
    <section>
      <p-checkbox data-summary-checkbox binary="true" inputId="dlgprexprt1"
      [formControl]="formGroup.controls['includeSummary']"></p-checkbox>
      <label for="dlgprexprt1">Summary</label>
    </section>
    <section>
      <p-checkbox data-cash-values-checkbox inputId="dlgprexprt2" binary="true"
      [formControl]="formGroup.controls['includeCashValues']"></p-checkbox>
      <label for="dlgprexprt2">Cash Values</label>
    </section>
    <section>
      <p-checkbox data-orders-checkbox inputId="dlgprorders2" binary="true"
      [formControl]="formGroup.controls['includeOrders']"></p-checkbox>
        <label for="dlgprorders2">Orders</label>
      <div class="radio-group" radio-group data-orders-radio-group>
        <span>Positions with no orders: </span>
        <p-radioButton data-show-radio-button name="positions-with-no-orders" value="SHOW" inputId="dlgprexprt3"
        [formControl]="positionsWithNoOrders"></p-radioButton>
        <label for="dlgprexprt3">Show</label>&nbsp;
        <p-radioButton data-hide-radio-button name="positions-with-no-orders" value="HIDE"  inputId="dlgprexprt4"
        [formControl]="positionsWithNoOrders"></p-radioButton>
        <label for="dlgprexprt4">Hide</label>
      </div>
    </section>
    <section>
      <p-checkbox data-allocations-checkbox inputId="dlgprexprt5" binary="true"
      [formControl]="formGroup.controls['includeAllocations']"></p-checkbox>
      <label for="dlgprexprt5">Allocations</label>
      <div>
        <div class="radio-group" data-allocations-display-radio-group>
          <span>Display: </span>
          <p-radioButton data-dollar-radio-button name="allocations-display" value="DOLLAR" inputId="dlgprexprt6"
          [formControl]="allocationsDisplay"></p-radioButton>
          <label for="dlgprexprt6">$</label>&nbsp;
          <p-radioButton data-percent-radio-button name="allocations-display" value="PERCENT" inputId="dlgprexprt7"
          [formControl]="allocationsDisplay"></p-radioButton>
          <label for="dlgprexprt7">%</label>
        </div>

        <div class="radio-group" data-allocations-group-by-radio-group>
          <span>Group by: </span>
          <p-radioButton data-category-radio-button name="allocations-group-by" value="SEC_CATEGORY"
          inputId="dlgprexprt8" [formControl]="allocationsGroupBy"></p-radioButton>
          <label for="dlgprexprt8">{{data.customCategoryName}}</label>&nbsp;
          <p-radioButton data-security-type-radio-button name="allocations-group-by" value="SEC_TYPE"
          inputId="dlgprexprt9" [formControl]="allocationsGroupBy"></p-radioButton>
          <label for="dlgprexprt9">Security type</label>&nbsp;
          <p-radioButton data-position-radio-button name="allocations-group-by" value="POSITION" label="Position"
          inputId="dlgprexprt10" [formControl]="allocationsGroupBy"></p-radioButton>
          <label for="dlgprexprt10">Position</label>
        </div>

        <div class="radio-group" data-allocations-variance-radio-group>
          <span>Variance: </span>
          <p-radioButton data-rel-radio-button name="allocations-variance" value="REL"
          inputId="dlgprexprt11" [formControl]="allocationsVariance"></p-radioButton>
          <label for="dlgprexprt11">Rel</label>
          <p-radioButton data-abs-radio-button name="allocations-variance" value="ABS"
          inputId="dlgprexprt12" [formControl]="allocationsVariance"></p-radioButton>
          <label for="dlgprexprt12">Abs</label>
        </div>

        <div class="radio-group" data-allocations-excluded-positions-radio-group>
          <span>Excluded positions: </span>
          <p-radioButton data-show-radio-button name="allocations-excluded-positions" value="SHOW"
          inputId="dlgprexprt13" [formControl]="allocationsExcludedPositions"></p-radioButton>
          <label for="dlgprexprt13">Show</label>
          <p-radioButton data-hide-radio-button name="allocations-excluded-positions" value="HIDE"
          inputId="dlgprexprt14" [formControl]="allocationsExcludedPositions"></p-radioButton>
          <label for="dlgprexprt14">Hide</label>
        </div>
      </div>
    </section>
    <section>
      <p-checkbox data-allocation-chart-checkbox  binary="true" inputId="dlgprexprt15"
        [formControl]="formGroup.controls['includeAllocationChart']">
      </p-checkbox>
      <label for="dlgprexprt15">Allocation Chart</label>
      <div class="radio-group" data-allocation-chart-group-by-radio-group>
        <span>Group by: </span>
        <p-radioButton data-category-radio-button inputId="dlgprexprt16" value="SEC_CATEGORY"
        [formControl]="allocationChartGroupBy"></p-radioButton>
        <label for="dlgprexprt16">{{data.customCategoryName}}</label>&nbsp;
        <p-radioButton data-security-type-radio-button inputId="dlgprexprt17" value="SEC_TYPE"
        [formControl]="allocationChartGroupBy"></p-radioButton>
        <label for="dlgprexprt17">Security type</label>
      </div>
    </section>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn-medium-secondary" data-close-button (click)="close()">Cancel</button>
  <button class="btn-medium-primary" data-continue-button [disabled]="!isFormValid" (click)="continue()">Continue
  </button>
</mat-dialog-actions>
